export default {
  /**
   * Production
   *
   */
  // apiUri: 'https://icel.or.id/api/v1/',
  // apiHost: 'https://icel.or.id',
  // appUri: 'https://icel.or.id/',

  /**
   * Development
   *
   */
  apiUri: 'https://staging-v2.icel.or.id/api/v1/',
  apiHost: 'https://staging-v2.icel.or.id',
  appUri: 'https://staging-v2.icel.or.id/',

  /**
   * Localhost
   *
   */
  // apiUri: 'http://localhost:5204/api/v1/',
  // apiHost: 'http://localhost:5204',
  // appUri: 'http://localhost:8080/',

  appPath: '/',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  appName: 'ICEL',
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',
};
